import { render, staticRenderFns } from "./LoginQuick.vue?vue&type=template&id=26b6ed93&lang=pug&"
import script from "./LoginQuick.vue?vue&type=script&lang=js&"
export * from "./LoginQuick.vue?vue&type=script&lang=js&"
import style0 from "./LoginQuick.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports